<template>
<div class="container">
<ul>
  <li v-for="(faq, index) in exclusiveFaqsData && exclusiveFaqsData.menu_items" :key="index" :style="index < (exclusiveFaqsData && exclusiveFaqsData.menu_items && exclusiveFaqsData.menu_items.length - 1) ? 'border-bottom: 1px solid #a9aaa9;' : ''">
    <input type="checkbox" checked>
    <i></i>
    <h5 class="exc-grey" v-html="faq.question"></h5>
    <p class="exc-grey-content pl-3 pr-3" v-html="faq.answer"></p>
  </li>
</ul>
</div>
</template>

<script>
export default {
  props: ['exclusiveFaqsData']
}
</script>

<style scoped>
  .transition, p, ul li i:before, ul li i:after {
    transition: all 0.25s ease-in-out;
  }
  .exc-grey {
    color: #434343;
    font-weight: 600;
    -webkit-text-stroke: 0.4px #fff;
    font-size: 0.8rem;
    letter-spacing: 0px;
    margin-bottom: 0;
  }
  .exc-grey-content {
    color: #5b5b5b;
    margin-bottom: 10px;
    font-size: 0.8rem;
    letter-spacing: 0px;
    margin-top: 10px;
  }
  .flipIn, h1, ul li {
    animation: flipdown 0.5s ease both;
  }
  .no-select, h5 {
    -webkit-tap-highlight-color: rgba(134, 97, 97, 0);
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  h1, h5 {
    color: #ff6873;
  }

  h5 {
    text-align: left;
    color: #a9aaa9;
  }

  p {
    color: #a9aaa9;
    font-size: 17px;
    line-height: 26px;
    letter-spacing: 1px;
    position: relative;
    overflow: hidden;
    max-height: 800px;
    opacity: 1;
    transform: translate(0, 0);
    margin-top: 14px;
    z-index: 2;
    text-align: left;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  ul li {
    position: relative;
    padding: 0;
    margin: 0;
    padding-bottom: 4px;
    padding-top: 18px;
  }
  ul li:nth-of-type(1) {
    animation-delay: 0.5s;
  }
  ul li:nth-of-type(2) {
    animation-delay: 0.75s;
  }
  ul li:nth-of-type(3) {
    animation-delay: 1s;
  }
  ul li:last-of-type {
    padding-bottom: 0;
  }
  ul li i {
    position: absolute;
    transform: translate(-6px, 0);
    margin-top: 5px;
    right: 0;
  }
  ul li i:before, ul li i:after {
    content: "";
    position: absolute;
    background-color: #1a1f29;
    width: 1px;
    height: 7px;
  }
  ul li i:before {
    transform: translate(-2px, 0) rotate(224deg);
  }
  ul li i:after {
    transform: translate(2px, 0) rotate(131deg);
  }
  ul li input[type=checkbox] {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
    cursor: pointer;
    left: 0px;
  }
  ul li input[type=checkbox]:checked ~ p {
    margin-top: 0;
    max-height: 0;
    opacity: 0;
    transform: translate(0, 50%);
    left: 0px;
  }
  ul li input[type=checkbox]:checked ~ i:before {
    transform: translate(-7px, 0px) rotate(131deg);
  }
  ul li input[type=checkbox]:checked ~ i:after {
    transform: translate(-2px, 0) rotate(224deg);
  }

  @keyframes flipdown {
    0% {
      opacity: 0;
      transform-origin: top center;
      transform: rotateX(-90deg);
    }
    5% {
      opacity: 1;
    }
    80% {
      transform: rotateX(8deg);
    }
    83% {
      transform: rotateX(6deg);
    }
    92% {
      transform: rotateX(-3deg);
    }
    100% {
      transform-origin: top center;
      transform: rotateX(0deg);
    }
  }

  @media screen and (max-width: 991px) {

    .container {
      width: 95%;
    }

    h5 {
      width: 85%;
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// exclusiveFaqs.vue?58a58ecd